<template>
  <div id="app">
    <router-view />
    <PaySuccessDialog ref="paySuccessDialog" />
    <WxPayQrCode ref="wxPayQrCode" />
  </div>
</template>
<script>
import { addCount } from "./api/homeData";
import { addEvent, removeEvent } from "@/utils/eventList.js";
import PaySuccessDialog from "@/views/pay-page/PaySuccessDialog.vue";
import WxPayQrCode from "@/components/buy-modal/wxPayQrCode.vue";
import { setToken } from "@/utils/auth.js";
export default {
  components: { PaySuccessDialog, WxPayQrCode },
  data() {
    return {};
  },
  watch: {
    "$store.state.zfbPaySuccess": function (success) {
      if (success) {
        try {
          this.$refs.paySuccessDialog.open();
        } catch (err) {
          console.error(err);
        }
        this.$nextTick(() => {
          this.$store.commit("SET_ZFB_PAY_SUCCESS", false);
        });
      }
    },
    "$store.state.wxPaySuccess": function (success) {
      if (success) {
        this.$refs.paySuccessDialog?.open();
        this.$nextTick(() => {
          this.$store.commit("SET_WX_PAY_SUCCESS", false);
        });
      }
    },
    "$store.state.wxOrderData": function (data) {
      this.$refs.wxPayQrCode?.open(data);
    },
  },
  methods: {
    checkUrlToken() {
      // 从URL参数中获取token
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get('token');
      
      if (token) {
        // 设置token到store中
        this.$store.commit('user/SET_TOKEN', token);
        
        // 获取用户信息
        this.$store.dispatch('user/getInfo').then(() => {
          console.log('通过URL参数token自动登录成功');
          
          // 可选：移除URL中的token参数
          if (window.history.replaceState) {
            const newUrl = window.location.href.replace(/(\?|&)token=[^&]*(&|$)/, function(match, p1, p2) {
              return p2 === '&' ? p1 : '';
            });
            window.history.replaceState({}, document.title, newUrl);
          }
        }).catch(error => {
          console.error('通过URL参数token自动登录失败', error);
          // token无效时可以清除
          this.$store.commit('user/SET_TOKEN', '');
        });
      }
    },
    bindScrollEvent() {
      window.addEventListener("scroll", this.scrollEvent);
    },
    unBindScrollEvent() {
      window.removeEventListener("scroll", this.scrollEvent);
      window._scrollFunList = [];
    },
    scrollEvent(e) {
      if (Object.prototype.toString.call(window._scrollFunList) === "[object Array]") {
        window._scrollFunList.forEach(tar => {
          if (tar) {
            // console.log("tar : ", tar);
            try {
              tar.fun(e);
            } catch (error) {
              console.error(error);
            }
          }
        });
      }
    },
    initZfbPaySuccessEvent() {
      localStorage.removeItem("zfbPaySuccess");
      addEvent("storage", "zfbPaySuccess", (e, key) => {
        if (e.newValue === "true") {
          localStorage.removeItem("zfbPaySuccess");
          this.$store.commit("CLOSE_PAY_PAGE");
          this.$store.commit("SET_ZFB_PAY_SUCCESS", true);
        }
      });
    },
  },
  beforeCreate() {
    window._scrollFunList = [];
    window._addScrollFun = function (key, fun) {
      if (key && typeof key === "string" && fun && typeof fun === "function") {
        if (Object.prototype.toString.call(window._scrollFunList) === "[object Array]") {
          window._scrollFunList.push({ key, fun });
        }
      }
    };
    window._removeScrollFun = function (key) {
      if (key && typeof key === "string") {
        const index = window._scrollFunList.findIndex(item => item.key === key);
        if (index !== -1) {
          window._scrollFunList.splice(index, 1);
        }
      }
    };
  },
  mounted() {
    new this.$wow.WOW({
      boxClass: "wow",
      offset: 0,
      live: false,
    }).init();
    try {
      addCount();
    } catch (error) {}
    this.bindScrollEvent();
    this.initZfbPaySuccessEvent();
    this.checkUrlToken();
  },
  beforeDestroy() {
    this.unBindScrollEvent();
    removeEvent("storage", "zfbPaySuccess");
  },
};
</script>

<style lang="less">
// @import '/src/assets/style/common.less';
#app {
  font-family: SourceHanSansCN-Normal, Helvetica, Arial, sans-serif;
  height: 100%;
  //   -webkit-font-smoothing: antialiased;
  //   -moz-osx-font-smoothing: grayscale;
  //   text-align: center;
  //   color: #2c3e50;
}

// nav {
//   padding: 30px;

//   a {
//     font-weight: bold;
//     color: #2c3e50;

//     &.router-link-exact-active {
//       color: #42b983;
//     }
//   }
// }
</style>
